
import axios from 'axios'
// 注册全局变量
import global from '@/assets/js/global'



/**
 * 
 * @param {*} lang 语言
 * @param {*} token 令牌
 * @param {*} ps 每页显示多少条
 * @param {*} p 请求第几页的数据
 * @returns 
 */
export default function getPageData(lang, token, url, ps, p, params) {
    const data = axios.get(
        `${url}?ps=${ps}&p=${p}${params}`, 
        {
            headers: {
                // 'Content-Type': 'multipart/form-data'
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept-Language': lang,
                'token': token,
                // 添加 APP_ID 和 APP_KEY 到请求头
                // 注意：app-id 和 app-key 是大小写敏感的
                //      另外不要用下划线，用连字符。
                'app-id': global.app_id,
                'app-key': global.app_key,
            }
        }
    )
    .then((res) =>  {
        // 从 API 接口得到所有可用的权组
        // console.log(res.data.data.items) 
        return res.data
    })
    .catch((err) => {
        console.log(err)
    })

  return { data }
}
